import { Component,OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

export class ToggleObject{
  name?: string;
  value?: boolean;
}

@Component({
  selector: 'teiasoft-toggle',
  templateUrl: './teiasoft-toggle.component.html',
  styleUrls: ['./teiasoft-toggle.component.scss']
})
export class TeiasoftToggleComponent implements OnInit, OnChanges {
  @Input() theme: string = 'silver';
  @Input() isOn: boolean = false;
  @Input() labelText: string = "";
  @Input() isValid: boolean = true;
  @Input() isRequired: boolean = false;
  @Input() spaceLabel: boolean = false;
  @Input() name: string = "";

  @Output() onToggleChanged: EventEmitter<ToggleObject> = new EventEmitter();

  ngOnInit(): void {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["isOn"]){
      this.isOn = changes["isOn"].currentValue;
    }

    if (changes && changes["name"]){
      this.name = changes["name"].currentValue;
    }
  }

  /* EVENTS */
  onToggleClick(){
    this.isOn = !this.isOn;
    let _ret: ToggleObject = new ToggleObject();
    _ret.name = this.name;
    _ret.value = this.isOn;
    this.onToggleChanged.emit(_ret);
  }

}
